import { Reveal } from "../components/Reveal";

const LegalPage = ({ title, children }) => (
    <section className="mx-auto max-w-3xl px-6 pb-28 pt-44" data-testid="legal-page">
        <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand">
                Transportes Alzira, Lda.
            </p>
            <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">
                {title}
            </h1>
            <div className="mt-12 space-y-6 text-sm leading-relaxed text-zinc-400 md:text-base">
                {children}
            </div>
        </Reveal>
    </section>
);

export const LegalPrivacy = () => (
    <LegalPage title="Política de Privacidade">
        <p>
            A Transportes Alzira, Lda. respeita a privacidade dos visitantes do
            seu website e compromete-se a proteger os dados pessoais que lhe
            sejam confiados, em conformidade com o Regulamento Geral sobre a
            Proteção de Dados (RGPD).
        </p>
        <p>
            Os dados recolhidos através do formulário de contacto — nome,
            empresa, email, telefone e detalhes da operação — são utilizados
            exclusivamente para responder ao seu pedido de orçamento ou
            contacto, não sendo partilhados com terceiros para fins comerciais.
        </p>
        <p>
            Os dados são conservados apenas pelo período necessário à gestão da
            relação comercial. Pode, a qualquer momento, solicitar o acesso,
            retificação ou eliminação dos seus dados através do email
            talzira71@gmail.com.
        </p>
    </LegalPage>
);

export const LegalCookies = () => (
    <LegalPage title="Política de Cookies">
        <p>
            Este website utiliza cookies estritamente necessários ao seu
            funcionamento técnico e, eventualmente, cookies de análise
            estatística de navegação, com o objetivo de melhorar a experiência
            do utilizador.
        </p>
        <p>
            Não são utilizados cookies para fins publicitários ou de
            segmentação. Pode configurar o seu navegador para recusar cookies,
            sendo que algumas funcionalidades do website poderão ficar
            limitadas.
        </p>
    </LegalPage>
);

export const LegalTerms = () => (
    <LegalPage title="Termos e Condições">
        <p>
            Os conteúdos deste website têm caráter informativo e destinam-se a
            apresentar a atividade da Transportes Alzira, Lda., os seus
            serviços e a sua frota.
        </p>
        <p>
            Os pedidos de orçamento submetidos através do website não
            constituem compromisso contratual; as condições de cada operação
            são sempre formalizadas entre as partes.
        </p>
        <p>
            Todos os conteúdos, textos e imagens são propriedade da Transportes
            Alzira, Lda. ou utilizados com autorização, não podendo ser
            reproduzidos sem consentimento prévio.
        </p>
    </LegalPage>
);
